<div class="language-selector">
  <button
    class="language-selector__button"
    [attr.aria-label]="'app.select_language' | translate"
    (click)="toggleDropdown($event)"
  >
    <span class="language-code">{{ (selectedLanguage$ | async)?.toUpperCase() }}</span>
    <svg
      class="selector-icon"
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        d="M12.87 15.07l-2.54-2.51.03-.03A17.52 17.52 0 0 0 14.07 6H17V4h-7V2H8v2H1v2h11.17C11.5 7.92 10.44 9.75 9 11.35 8.07 10.32 7.3 9.19 6.69 8h-2c.73 1.63 1.73 3.17 2.98 4.56l-5.09 5.02L4 19l5-5 3.11 3.11.76-2.04zM18.5 10h-2L12 22h2l1.12-3h4.75L21 22h2l-4.5-12zm-2.62 7l1.62-4.33L19.12 17h-3.24z"
      ></path>
    </svg>
  </button>

  <!-- Custom dropdown menu -->
  <div class="custom-dropdown" *ngIf="isDropdownOpen">
    <div class="dropdown-header">
      {{ 'app.select_language' | translate }}
    </div>
    <div class="dropdown-items">
      <button
        *ngFor="let lang of languages$ | async"
        (click)="selectLanguage(lang.code)"
        [class.selected]="(selectedLanguage$ | async) === lang.code"
        class="dropdown-item"
      >
        <div class="language-content">
          <span class="language-code-bubble">{{ lang.code.toUpperCase() }}</span>
          <span class="language-name">{{ lang.name }}</span>
        </div>
        <svg
          *ngIf="(selectedLanguage$ | async) === lang.code"
          class="check-icon"
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
        >
          <path fill="currentColor" d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path>
        </svg>
      </button>
    </div>
  </div>
</div>
